import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import Contact from './contact';
import NewContact from './newContact';
import { Scrollbars } from 'react-custom-scrollbars';

class Back extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreatingNewContact: false
    }
  }

  creatingNewContact = () => {
    this.setState({
      isCreatingNewContact: true
    })
  };
  cancelCreateContact = () => {
    this.setState({
      isCreatingNewContact: false
    })
  };
  shouldBeOddBackground = (index) => {
    // eslint-disable-next-line
    return this.state.isCreatingNewContact ? index % 2 == 1 : index % 2 != 1;
  };
  render() {
    const { editContact, createContact, contacts, showFront, projectName, projectId, role, projectStatus } = this.props;
    return (
      <div style={styles.body} id={projectId + 'bodyback'}>
        <div style={[styles.cardHeader, role === "Insights" && styles.insightsCardHeader,
        projectStatus === 1 && styles.outDated,
        projectStatus === 2 && styles.overAllocation]}>
          <div style={styles.backBtn}>
            <i onClick={showFront} className="fa fa-arrow-left waves-icon" />
          </div>
          <div style={styles.title}>{projectName}</div>
          <div style={styles.addBtn}>
            <i onClick={this.creatingNewContact} className="fa fa-user-plus waves-icon" />
          </div>
        </div>
        <Scrollbars
          autoHide={true}
          style={role === "Insights" ? styles.insightsCardBody : styles.cardBody}>
          {this.state.isCreatingNewContact ?
            <NewContact
              cancelCreateContact={this.cancelCreateContact}
              createContact={createContact}
            /> : null}

          {
            contacts.map((contact, i) => {
              return (
                <Contact
                  key={contact.id}
                  style={[this.shouldBeOddBackground(i) && styles.oddBackground]}
                  {...contact}
                  editContact={(contactNew) => editContact(contactNew, contact, i)}
                />
              )
            })
          }
        </Scrollbars>
      </div>
    );
  }
}

var styles = {
  body: {
    overflow: 'hidden'
  },
  oddBackground: {
    backgroundColor: greyScaleColors.greyLighter
  },
  cardHeader: {
    backgroundColor: semanticColors.primary,
    textAlign: 'center',
    height: '45px',
    width: '100%',
    lineHeight: '45px',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#ffffff',
    padding: '0px',
    borderTopLeftRadius: '2px',
    borderTopRightRadius: '2px'
  },
  insightsCardHeader: {
    height: '45px'
  },
  overAllocation: {
    borderRightStyle: 'solid',
    borderRightWidth: '10px',
    borderRightColor: semanticColors.danger
  },
  outDated: {
    borderRightStyle: 'solid',
    borderRightWidth: '10px',
    borderRightColor: semanticColors.warning
  },
  cardBody: {
    backgroundColor: semanticColors.default,
    height: '560px',
    width: '100%',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  insightsCardBody: {
    backgroundColor: semanticColors.default,
    height: '265px',
    width: '100%',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  backBtn: {
    zIndex: '1',
    position: 'relative',
    float: 'left',
    height: '45px',
    paddingTop: 15,
  },
  title: {
    position: 'absolute',
    padding: '0px 45px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '100%',
    textAlign: 'center'
  },
  addBtn: {
    zIndex: '1',
    position: 'relative',
    float: 'right',
    height: '45px',
    paddingTop: 15,
  }
}
Back.propTypes = {
  projectName: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  contacts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    name: PropTypes.string,
    telephone: PropTypes.string,
    email: PropTypes.string
  })).isRequired,
  editContact: PropTypes.func.isRequired,
  createContact: PropTypes.func.isRequired
};
export default Radium(Back);



// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/ProjectCard/back.jsx